import React from "react";
import { withTranslation } from 'react-i18next';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { HOST, API_URL } from '../auxiliar/constants'
import iconoBuscadorNegro from '../../images/btn_filtros/filtros_btn.png'
import i18next from 'i18next'
import Filters from './Filters'

import { ClusterEmitter } from '../Map/ClusterGroup'

class FiltersTrigger extends React.Component {

    state = {
        loading: true,
        filteringResults: false,
        touched: false,
        habitatsSIBIC: [],
        taxonomiesSIBIC: [],
        habitatsEASIN: [],
        taxonomiesEASIN: [],
        sibicEasinRelations: [],
        dataSource: 'BOTH',
        scientificName: "",
        commonName: "",
        selectedHabitats: [],
        selectedTaxonomy: ""
    }

    componentDidMount() {
        this.fetchCatalogs()
        i18next.on('languageChanged', () => {this.refreshHabitats()})
    }

    async refreshHabitats(){
        let habitatsSIBIC = []
        await fetch(`https://eei.sibic.org/API/invasaqua.php?function=getHabitats&lang=${this.props.i18n.language}`)
            .then(response => response.json())
            .then(data => {
                habitatsSIBIC = data
            })
        this.setState({
            habitatsSIBIC
        })
    }

    async fetchCatalogs() {
        let habitatsSIBIC = []
        let taxonomiesSIBIC = []
        let habitatsEASIN = []
        let taxonomiesEASIN = []
        let sibicEasinRelations = []

        await fetch(`https://eei.sibic.org/API/invasaqua.php?function=getHabitats&lang=${this.props.i18n.language}`)
            .then(response => response.json())
            .then(data => {
                habitatsSIBIC = data
            })
        await fetch('https://eei.sibic.org/API/invasaqua.php?function=getTaxonomicGroup')
            .then(response => response.json())
            .then(data => {
                taxonomiesSIBIC = data
            })

        await fetch(`${HOST}${API_URL}/?function=getHabitats`)
            .then(response => response.json())
            .then(data => {
                habitatsEASIN = data
            })

        await fetch(`${HOST}${API_URL}/?function=getTaxonomy`)
            .then(response => response.json())
            .then(data => {
                taxonomiesEASIN = data
            })

        await fetch(`${HOST}${API_URL}/?function=getRelations`)
            .then(response => response.json())
            .then(data => {
                sibicEasinRelations = data
            })

        this.setState({
            habitatsSIBIC,
            taxonomiesSIBIC,
            habitatsEASIN,
            taxonomiesEASIN,
            sibicEasinRelations,
            loading: false
        })
    }

    extractQueryParams = (filters, type) => {
        let filtObj = {
            function: type === 'SIBIC' ? 'getSibicFilter' : type === 'EASIN' ? 'getEasinFilter' : null,
            spe: filters.scientificName,
            tax: filters.selectedTaxonomy,
            com: filters.commonName,
            hab: filters.selectedHabitats
        }

        let params = new URLSearchParams(filtObj)
        let toRemove = []
        params.forEach((v, k) => {
          if (!v) {
              toRemove.push(k)
          }
        })
        toRemove.forEach(k => params.delete(k))
        let size = Array.from(params).length
        return size === 1 ? null : params.toString()
    }

    applyFilters = (filters) => {

        this.setState({
            filteringResults: true
        })

        if (filters.dataSource === "BOTH") {
            let queryS = this.extractQueryParams(filters, "SIBIC")
            let queryE = this.extractQueryParams(filters, "EASIN")
            if (queryS && queryE) {
                this.fetchFilteredIds(queryS, queryE, filters)
            } else {
                ClusterEmitter.emit('apply-filters', null, null)
                //this.props.onApplyFilters(null, null)
                this.setState({
                    touched: true,
                    filteringResults: false,
                    dataSource: filters.dataSource,
                    scientificName: filters.scientificName,
                    commonName: filters.commonName,
                    selectedHabitats: filters.selectedHabitats,
                    selectedTaxonomy: filters.selectedTaxonomy
                })
            }
        } else if (filters.dataSource === "SIBIC") {
            let query = this.extractQueryParams(filters, "SIBIC")
            if (query) {
                this.fetchFilteredIds(query, null, filters)
            } else {
                ClusterEmitter.emit('apply-filters', null, [])
                //this.props.onApplyFilters(null, [])
                this.setState({
                    touched: true,
                    filteringResults: false,
                    dataSource: filters.dataSource,
                    scientificName: filters.scientificName,
                    commonName: filters.commonName,
                    selectedHabitats: filters.selectedHabitats,
                    selectedTaxonomy: filters.selectedTaxonomy
                })
            }

        } else {
            let query = this.extractQueryParams(filters, "EASIN")
            if (query) {
                this.fetchFilteredIds(null, query, filters)
            } else {
                ClusterEmitter.emit('apply-filters', [], null)
                //this.props.onApplyFilters([], null)
                this.setState({
                    touched: true,
                    filteringResults: false,
                    dataSource: filters.dataSource,
                    scientificName: filters.scientificName,
                    commonName: filters.commonName,
                    selectedHabitats: filters.selectedHabitats,
                    selectedTaxonomy: filters.selectedTaxonomy
                })
            }
        }
    }

    async fetchFilteredIds(querySibic, queryEasin, filters){
        let sibicIds = []
        let easinIds = []

        if (querySibic) {
            await fetch(`https://eei.sibic.org/API/invasaqua.php?${querySibic}`)
                .then(response => response.json())
                .then(data => {
                    sibicIds = data.map(spec => spec.species_id)
                })
        }

        if (queryEasin) {
            await fetch(`${HOST}${API_URL}/?${queryEasin}`)
                .then(response => response.json())
                .then(data => {
                    easinIds = data.map(spec => spec.speciesCatalogueId)
                })
        }
        ClusterEmitter.emit('apply-filters', sibicIds, easinIds)
        //this.props.onApplyFilters(sibicIds, easinIds)

        this.setState({
            touched: true,
            filteringResults: false,
            dataSource: filters.dataSource,
            scientificName: filters.scientificName,
            commonName: filters.commonName,
            selectedHabitats: filters.selectedHabitats,
            selectedTaxonomy: filters.selectedTaxonomy
        })

    }

    renderSelectorContent = () => {
        return <Filters
                    touched={this.state.touched}
                    filteringResults={this.state.filteringResults}
                    loading={this.state.loading}
                    onFilter={this.applyFilters}
                    habitatsSIBIC={this.state.habitatsSIBIC}
                    taxonomiesSIBIC={this.state.taxonomiesSIBIC}
                    habitatsEASIN={this.state.habitatsEASIN}
                    taxonomiesEASIN={this.state.taxonomiesEASIN}
                    dataSource={this.state.dataSource}
                    scientificName={this.state.scientificName}
                    commonName={this.state.commonName}
                    selectedHabitats={this.state.selectedHabitats}
                    selectedTaxonomy={this.state.selectedTaxonomy}
                />
    }

    render() {

        const { t } = this.props

        return (
            <div className="marco_btn float-right mt-1 mr-1" style={{ backgroundColor: this.props.tileType === "HEAT" ? "#bfd128b3": "#bfd128", cursor:  this.props.tileType === "HEAT" ? 'not-allowed' : 'pointer' }}>
                <OverlayTrigger
                    className="visorFiltersPop"
                    trigger="click"
                    key={'filters_popover'}
                    placement={'bottom'}
                    rootClose
                    overlay={
                        <Popover style={{ width: 'auto', minWidth: 500}} className="visorFiltersPop">
                          <Popover.Content style={{padding: 0}}>
                            {this.renderSelectorContent()}
                          </Popover.Content>
                        </Popover>
                    }>
                        <Button
                            style={{ cursor:  this.props.tileType === "HEAT" ? 'not-allowed' : 'pointer' }}
                            disabled={this.props.tileType === "HEAT"}
                            variant="light"
                            size="sm"
                            className="btn-filtros m-1 float-right">
                                <img className="pb-1 mr-2" src={iconoBuscadorNegro} alt="icono buscador" />{t("filtro")}
                        </Button>
                </OverlayTrigger>
            </div>
        )
    }
}

export default withTranslation()(FiltersTrigger)
